/* Bandenmeesters 2.1 — canonical mobile header/menu controller, 2026-09-10. */
(()=>{
  if(window.__bmMobileHeaderRuntime)return;
  window.__bmMobileHeaderRuntime=true;

  const GENERATION_IMAGE_CACHE_KEY='bm_generation_image_cache_v1';
  const mqDesktop=window.matchMedia('(min-width: 990px)');

  const getSelectorUrl=()=>{
    const root=window.routes?.root_url||'/';
    return `${root}${root.endsWith('/')?'':'/'}#voertuigselector`;
  };

  const vehicleLabel=(vehicle)=>{
    const api=window.BandenmeestersVehicle;
    if(api?.vehicleLabel)return api.vehicleLabel(vehicle);
    return [vehicle?.brand?.name||'',vehicle?.model?.name||'',vehicle?.generation?.name||''].filter(Boolean).join(' ');
  };

  const readImageCache=()=>{
    try{return JSON.parse(window.localStorage.getItem(GENERATION_IMAGE_CACHE_KEY)||'{}')||{}}
    catch(_){return {}}
  };

  const writeImageCache=(generationId,imageUrl)=>{
    if(!generationId||!imageUrl)return;
    try{
      const cache=readImageCache();
      cache[String(generationId)]=imageUrl;
      const keys=Object.keys(cache);
      if(keys.length>24)keys.slice(0,keys.length-24).forEach(key=>delete cache[key]);
      window.localStorage.setItem(GENERATION_IMAGE_CACHE_KEY,JSON.stringify(cache));
    }catch(_){}
  };

  const cachedGenerationImage=(vehicle)=>{
    const id=vehicle?.generation?.id;
    if(!id)return '';
    return vehicle?.generation?.image||readImageCache()[String(id)]||'';
  };

  const renderMobileVehicleImage=(card,active,imageUrl='')=>{
    if(!card)return;
    const image=card.querySelector('[data-bm-mobile-vehicle-image]');
    const icon=card.querySelector('[data-bm-mobile-vehicle-icon]');
    const hasImage=Boolean(active&&imageUrl);
    card.classList.toggle('has-generation-image',hasImage);

    if(image){
      if(hasImage){
        image.src=imageUrl;
        image.alt=vehicleLabel(active)||'Gekozen auto';
        image.hidden=false;
      }else{
        image.removeAttribute('src');
        image.alt='';
        image.hidden=true;
      }
    }
    if(icon)icon.hidden=hasImage;
  };

  const resolveGenerationImage=async(active,card)=>{
    if(!active?.generation?.id||!active?.generation?.url||!card)return;
    const cached=cachedGenerationImage(active);
    if(cached){renderMobileVehicleImage(card,active,cached);return}

    const generationId=String(active.generation.id);
    try{
      const target=new URL(active.generation.url,window.location.origin);
      let imageUrl='';
      if(target.pathname.replace(/\/$/,'')===window.location.pathname.replace(/\/$/,'')){
        const local=document.querySelector('.bm-vehicle-hero__visual img, .bm-generation-image img');
        imageUrl=local?.currentSrc||local?.src||'';
      }
      if(!imageUrl){
        const response=await fetch(target.toString(),{credentials:'same-origin',headers:{'X-Requested-With':'XMLHttpRequest'}});
        if(!response.ok)return;
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const source=doc.querySelector('.bm-vehicle-hero__visual img, .bm-generation-image img');
        imageUrl=source?.getAttribute('src')||'';
      }
      if(!imageUrl)return;
      writeImageCache(generationId,imageUrl);
      const current=window.BandenmeestersVehicle?.getActive?.();
      if(String(current?.generation?.id||'')===generationId)renderMobileVehicleImage(card,current,imageUrl);
    }catch(_){}
  };

  const syncMobileVehicleUI=()=>{
    const api=window.BandenmeestersVehicle;
    if(!api?.getActive)return false;
    const active=api.getActive()||null;

    document.querySelectorAll('[data-bm-mobile-vehicle-card]').forEach(card=>{
      const label=card.querySelector('[data-bm-mobile-vehicle-label]');
      const note=card.querySelector('[data-bm-mobile-vehicle-note]');
      const action=card.querySelector('[data-bm-mobile-vehicle-action]');
      const change=card.querySelector('[data-bm-mobile-vehicle-change]');

      card.classList.toggle('has-vehicle',Boolean(active));
      if(label)label.textContent=active?vehicleLabel(active):'Selecteer merk, model en generatie';
      if(note)note.textContent=active?'Passende velgensets voor deze generatie.':'Toon alleen velgensets die bij jouw auto passen.';
      if(action){
        action.href=active?.generation?.url||getSelectorUrl();
        action.textContent=active?'Bekijk passende velgen →':'Kies jouw auto →';
      }
      if(change){
        change.href=getSelectorUrl();
        change.hidden=!active;
      }

      const cached=cachedGenerationImage(active);
      renderMobileVehicleImage(card,active,cached);
      if(active&&!cached)resolveGenerationImage(active,card);
    });

    document.querySelectorAll('[data-bm-mobile-vehicle-search], .bm-mobile-nav__item--vehicle-search').forEach(item=>{
      item.hidden=Boolean(active);
    });
    return true;
  };

  const shell={
    active:'',
    menuToggle:null,
    menuOverlay:null,
    searchToggle:null,
    searchOverlay:null,
    headerObserver:null,
    cartObserver:null
  };

  const activeOverlay=()=>shell.active==='menu'?shell.menuOverlay:shell.active==='search'?shell.searchOverlay:null;

  const resolveCurrentOverlay=(selector)=>{
    const candidates=[...document.querySelectorAll(selector)];
    if(!candidates.length)return null;
    const fresh=candidates.find(node=>node.closest('#header'))||candidates[0];
    candidates.forEach(node=>{
      if(node!==fresh&&node.dataset.bmPortaled==='true')node.remove();
    });
    return fresh;
  };

  const removePortaledShells=()=>{
    document.querySelectorAll('body > [data-bm-portaled="true"]').forEach(node=>node.remove());
    shell.menuOverlay=null;
    shell.searchOverlay=null;
  };

  const syncShellMetrics=()=>{
    const header=document.querySelector('#header');
    if(!header)return;
    const rect=header.getBoundingClientRect();
    const viewport=window.visualViewport;
    const viewportTop=viewport?.offsetTop||0;
    const viewportHeight=viewport?.height||window.innerHeight;
    const viewportBottom=viewportTop+viewportHeight;
    const headerBottom=Math.max(viewportTop,Math.min(viewportBottom,rect.bottom));
    const available=Math.max(0,viewportBottom-headerBottom);
    document.documentElement.style.setProperty('--bm-mobile-shell-top',`${Math.round(headerBottom)}px`);
    document.documentElement.style.setProperty('--bm-mobile-shell-height',`${Math.round(available)}px`);
  };

  const setShellState=(kind='')=>{
    const isMenu=kind==='menu';
    const isSearch=kind==='search';
    shell.active=kind;

    shell.menuToggle?.setAttribute('aria-expanded',String(isMenu));
    shell.searchToggle?.setAttribute('aria-expanded',String(isSearch));

    if(shell.menuOverlay){
      shell.menuOverlay.hidden=!isMenu;
      shell.menuOverlay.setAttribute('aria-hidden',String(!isMenu));
    }
    if(shell.searchOverlay){
      shell.searchOverlay.hidden=!isSearch;
      shell.searchOverlay.setAttribute('aria-hidden',String(!isSearch));
    }

    document.documentElement.classList.toggle('bm-mobile-shell-open',Boolean(kind));
    document.body.classList.toggle('bm-shell-menu-open',isMenu);
    document.body.classList.toggle('bm-shell-search-open',isSearch);
    if(kind)syncShellMetrics();
  };

  const closeShell=(restoreFocus=false)=>{
    const toggle=shell.active==='menu'?shell.menuToggle:shell.active==='search'?shell.searchToggle:null;
    setShellState('');
    if(restoreFocus&&toggle)window.requestAnimationFrame(()=>toggle.focus({preventScroll:true}));
  };

  const miniCartIsOpen=()=>document.body.classList.contains('header-mini-cart-open');
  const closeMiniCart=()=>{
    if(!miniCartIsOpen())return false;
    const closeButton=document.querySelector('#HeaderMiniCart .bm-mini-cart__close');
    if(!closeButton)return false;
    closeButton.click();
    return true;
  };

  const focusables=(root)=>{
    if(!root)return [];
    const selector='a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    return [...root.querySelectorAll(selector)].filter(el=>!el.hidden&&el.getAttribute('aria-hidden')!=='true'&&el.getClientRects().length>0);
  };

  const focusFirstInShell=()=>{
    const overlay=activeOverlay();
    if(!overlay)return;
    const preferred=shell.active==='search'
      ? overlay.querySelector('.bm-shell-search-input')
      : overlay.querySelector('[data-bm-mobile-vehicle-action], .bm-mobile-nav__link, .bm-mobile-nav__expand');
    const target=preferred||focusables(overlay)[0];
    target?.focus?.({preventScroll:true});
  };

  const openShell=(kind)=>{
    if(kind===shell.active){closeShell(true);return}
    closeMiniCart();
    setShellState(kind);
    window.requestAnimationFrame(()=>{
      focusFirstInShell();
      if(kind==='search')window.setTimeout(focusFirstInShell,40);
    });
  };

  const portalMobileShell=()=>{
    shell.menuToggle=document.querySelector('#header [data-bm-mobile-menu-toggle]');
    shell.searchToggle=document.querySelector('#header [data-bm-mobile-search-toggle]');
    shell.menuOverlay=resolveCurrentOverlay('[data-bm-mobile-menu-overlay]');
    shell.searchOverlay=resolveCurrentOverlay('[data-bm-mobile-search-overlay]');

    [shell.menuOverlay,shell.searchOverlay].forEach(overlay=>{
      if(!overlay)return;
      if(overlay.parentElement!==document.body)document.body.appendChild(overlay);
      overlay.dataset.bmPortaled='true';
    });

    syncShellMetrics();
    syncMobileVehicleUI();

    if('ResizeObserver'in window){
      shell.headerObserver?.disconnect?.();
      const header=document.querySelector('#header');
      if(header){
        shell.headerObserver=new ResizeObserver(syncShellMetrics);
        shell.headerObserver.observe(header);
      }
    }
  };

  const observeMiniCart=()=>{
    if(!('MutationObserver'in window)||!document.body)return;
    shell.cartObserver?.disconnect?.();
    shell.cartObserver=new MutationObserver(()=>{
      if(miniCartIsOpen()&&shell.active)closeShell(false);
    });
    shell.cartObserver.observe(document.body,{attributes:true,attributeFilter:['class']});
  };

  const toggleMobileSubmenu=(button)=>{
    const item=button.closest('.bm-mobile-nav__item');
    if(!item)return;
    const expanded=button.getAttribute('aria-expanded')==='true';
    const next=!expanded;
    button.setAttribute('aria-expanded',String(next));
    item.classList.toggle('is-expanded',next);
    const hiddenText=button.querySelector('.visually-hidden');
    if(hiddenText){
      hiddenText.textContent=next
        ? button.dataset.collapseText||hiddenText.textContent
        : button.dataset.expandText||hiddenText.textContent;
    }
  };

  const trapFocus=(event)=>{
    if(event.key!=='Tab'||!shell.active)return;
    const overlay=activeOverlay();
    if(!overlay)return;
    const items=focusables(overlay);
    if(!items.length){event.preventDefault();return}
    const first=items[0];
    const last=items[items.length-1];
    const current=document.activeElement;
    if(event.shiftKey){
      if(current===first||!overlay.contains(current)){
        event.preventDefault();
        last.focus({preventScroll:true});
      }
    }else if(current===last||!overlay.contains(current)){
      event.preventDefault();
      first.focus({preventScroll:true});
    }
  };

  const bind=()=>{
    portalMobileShell();
    observeMiniCart();

    document.addEventListener('click',event=>{
      const cartToggle=event.target.closest?.('#mini-cart-toggle');
      if(cartToggle){if(shell.active)closeShell(false);return}

      const account=event.target.closest?.('.head-slot-nav-link-account');
      if(account&&shell.active){closeShell(false);return}

      const menuToggle=event.target.closest?.('[data-bm-mobile-menu-toggle]');
      if(menuToggle){event.preventDefault();openShell('menu');return}

      const searchToggle=event.target.closest?.('[data-bm-mobile-search-toggle]');
      if(searchToggle){event.preventDefault();openShell('search');return}

      const expandButton=event.target.closest?.('.bm-mobile-menu-overlay .bm-mobile-nav__expand');
      if(expandButton){
        event.preventDefault();
        event.stopPropagation();
        toggleMobileSubmenu(expandButton);
        return;
      }

      if(event.target.closest?.('[data-bm-mobile-overlay-close]')){
        event.preventDefault();
        closeShell(true);
        return;
      }

      if(shell.active==='menu'&&event.target.closest?.('.bm-mobile-menu-overlay a'))closeShell(false);
    },true);

    document.addEventListener('keydown',event=>{
      if(event.key==='Escape'&&shell.active){
        event.preventDefault();
        closeShell(true);
        return;
      }
      trapFocus(event);
    });

    const refreshMetrics=()=>{if(shell.active)syncShellMetrics()};
    window.addEventListener('resize',refreshMetrics,{passive:true});
    window.addEventListener('scroll',refreshMetrics,{passive:true});
    window.visualViewport?.addEventListener('resize',refreshMetrics,{passive:true});
    window.visualViewport?.addEventListener('scroll',refreshMetrics,{passive:true});

    window.addEventListener('pageshow',()=>{
      closeShell(false);
      portalMobileShell();
      observeMiniCart();
    });

    document.addEventListener('shopify:section:unload',event=>{
      if(event.target?.querySelector?.('#header')){
        closeShell(false);
        removePortaledShells();
      }
    });

    document.addEventListener('shopify:section:load',()=>{
      closeShell(false);
      window.requestAnimationFrame(()=>{
        portalMobileShell();
        observeMiniCart();
      });
    });

    mqDesktop.addEventListener?.('change',()=>{if(mqDesktop.matches)closeShell(false)});
  };

  const syncSoon=()=>window.requestAnimationFrame(syncMobileVehicleUI);
  window.addEventListener('bm:vehicle:change',syncSoon);
  document.addEventListener('bm:vehicle:ready',syncSoon);

  const start=()=>{
    bind();
    if(!syncMobileVehicleUI()){
      const observer=new MutationObserver(()=>{
        if(syncMobileVehicleUI())observer.disconnect();
      });
      observer.observe(document.documentElement,{childList:true,subtree:true});
      window.setTimeout(()=>observer.disconnect(),5000);
    }
    window.setTimeout(syncMobileVehicleUI,250);
    window.setTimeout(syncMobileVehicleUI,1000);
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
